import React from 'react';
import classnames from 'classnames';
import { WithTranslation, withTranslation } from 'react-i18next';
import DateControls from './DateControlsLoadable';
import s from './DateNavigationRow.scss';

export interface Props {
  date?: string;
  isMobile?: boolean;
}

interface State {
  isFocused: boolean;
}

export class DateNavigationRow extends React.Component<
  Props & WithTranslation,
  State
> {
  readonly state = {
    isFocused: false,
  };

  render() {
    const { isMobile, t } = this.props;

    return (
      <div className={classnames(s['navigation-row'], isMobile && s['mobile'])}>
        {!isMobile && (
          <div className={s['flag-title']}>
            <div className={s['flag']} />
            <div className={s['big-title']}>
              {t!('dailyDev.title.daily')}
              <br />
              {t!('dailyDev.title.deviation')}
            </div>
          </div>
        )}
        <DateControls {...this.props} />
      </div>
    );
  }
}

export default withTranslation()(DateNavigationRow);
